import {FormField} from "./form-field";

export class FieldGroup {
    public name: string;
    public groupName: string;
    public fieldName: string;
    public outputName: string;
    public fields: FormField[] = [];
    public field: any;
    public tree: any;
    public items: FieldGroup[];
    public isgroup: boolean = true;
    public lead: boolean = false;
    public opened: boolean = false;
    public isVisibleInput: boolean = true;
    public isVisibleOutput: boolean = true;
    public order: number;
    public title: string = "";
    public tab: string = "";
    public dataSrc: string = null;
    public level: number;
    public orderNumber: number;
    public linkingRequirement: boolean;
    public linkingResult: boolean;
    public triggerChangeDetection: boolean = false; // this value should just be toggled when change detection should be triggered.
}
